import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfigEntityService } from 'src/app/core/services/config-entity.service';
import { GpoRegistry, GpoWithRegistryKeyName, UpdateGroupPolicyProp } from 'src/app/core/models/config-entities';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-update-gpo-properties',
  templateUrl: './update-gpo-properties.component.html',
  styleUrls: ['./update-gpo-properties.component.scss']
})
export class UpdateGpoPropertiesComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<UpdateGpoPropertiesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { gpoName: string, registryKeys: GpoRegistry[] },
    private configEntityService: ConfigEntityService,
    public spinner: NgxSpinnerService,
    public snackBar: MatSnackBar,
    private fb: FormBuilder,
  ) { }

  form: FormGroup;
  configItems: GpoRegistry[];
  selectedItem: GpoRegistry | null = null;
  gpoRegistry: GpoRegistry[] = [];

  ngOnInit(): void {
    this.configItems = this.data.registryKeys;
    this.createForm();
  }

  createForm() {
    this.spinner.show("gpoList")
    this.form = this.fb.group({
      selectedConfig: ['', Validators.required],
      action: ['', Validators.required]
    });
    this.configEntityService.getGpoPropValue(this.data.gpoName)
    .subscribe({
      next: (data: any) => {
        if(data) {
          this.gpoRegistry = JSON.parse(JSON.stringify(data?.message))
          this.spinner.hide("gpoList")
        }
      },
      error: (err) => {
        this.spinner.hide("gpoList")
      }
    })
    this.form.get('selectedConfig').valueChanges.subscribe(value => {
      this.selectedItem = this.configItems.find(item => item.humanReadableName === value);
      if(this.gpoRegistry){
        this.form.controls['action'].setValue(this.gpoRegistry?.filter(item => item.humanReadableName === value)![0]?.value || -1);
      }
      else{
        this.form.controls['action'].setValue(this.configItems?.filter(item => item.humanReadableName === value)![0]?.value || -1);
      }
    });
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  onSubmit(){
    if (this.form.valid && this.selectedItem) {
      this.spinner.show("gpoList");
      let value = this.form.value.action
      if(value == "-1"){
        this.snackBar.open("Only Enable and Disable actions are allowed.", "Ok", { duration: 3000});
      }
      if(this.selectedItem?.isReverse){
        if(value == "1"){
          value = "0";
        }
        else if (value == "0"){
          value = "1";
        }
      }
      let gpoToAdd: UpdateGroupPolicyProp = {
        username: "",
        password: "",
        gpoName : this.data.gpoName,
        registryName : this.selectedItem.registryName,
        registryKey : this.selectedItem.registryKey,
        registryValue: value
      }
      this.configEntityService.updateGroupPolicy(gpoToAdd)
      .subscribe({
        next: (data: any) => {
          this.spinner.hide("gpoList");
          if(data) {
            this.snackBar.open(data?.message, "Ok", { duration: 3000});
            this.dialogRef.close(false);
          }
          else{
            this.snackBar.open("Failed to add GPO.", "Ok", { duration: 3000});
          }
        },
        error: (err) => {
          this.spinner.hide("gpoList");
          console.error(err);
          this.snackBar.open("Failed to add GPO", "Ok", { duration: 3000});
          this.dialogRef.close(false);
        }
      })
    }
  }
}
